import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';

interface ShowModalProps {
    show: boolean;
    onClose: () => void;
    data: any[]; // updated to reflect an array
}

const ShowModal: React.FC<ShowModalProps> = ({ show, onClose, data }) => {
    const dataSource = Array.isArray(data) ? data : [];

    return (
        <Modal show={show} onHide={onClose} size="xl" centered backdrop= "static">
            <Modal.Header closeButton>
                <Modal.Title>Product Details</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <DataGrid
                    dataSource={dataSource}
                    showBorders={true}
                    columnAutoWidth={true}
                    rowAlternationEnabled={true}
                    onContentReady={(e) => {
                        const hasData = e.component.totalCount() > 0;
                        e.component.option("pager.visible", hasData);
                        e.component.option("paging.visible", hasData);
                    }}
                >
                    <Scrolling
                        mode='standard'
                        useNative={true}
                        scrollByContent={true}
                        scrollByThumb={true}
                    />


                    <Column cssClass='text-center' dataField="netWt" caption="Net Wt" dataType='number' format='#,##0.000' />
                    <Column cssClass='text-center' dataField="grossWt" caption="Gross Wt" dataType='number' format='#,##0.000' />
                    <Column cssClass='text-center' dataField="huid" caption="HUID" />
                    <Column cssClass='text-center' dataField="igiNo" caption="IGI Number" />
                    <Column cssClass='text-center' dataField="karat" caption="Metal KT" />
                    <Column cssClass='text-center' dataField="bagNo" caption="BagNo." />
                    <Column cssClass='text-center' dataField="labMrp" caption="Lab Mrp" dataType='number' format='#,##0.00' />
                    <Column cssClass='text-center' dataField="goldMrp" caption="Gold Mrp" dataType='number' format='#,##0.00' />
                    <Column cssClass='text-center' dataField="complexityName" caption="Complexity Name" />
                    <Column cssClass='text-center' dataField="complexityPercentage" caption="Complexity Value (%)" dataType='number' format='#,##0.00' />
                    <Column cssClass='text-center' dataField="materialType" caption="Material Type" />
                </DataGrid>
            </Modal.Body>
        </Modal>
    );
};

export default ShowModal;
